// @flow

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'PMT/i18n/I18n';

// -- constants
import Events from 'constants/Events';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu'

// -- views
import { Modal } from 'react-bootstrap';
import ItemSelectorView from './ItemSelectorView';

export default class ItemSelectorModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,
    options: PropTypes.array,
    values: PropTypes.array,

    onChange: PropTypes.func.isRequired,
  };

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('menu.item_selector.modal_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ItemSelectorView
            restaurantMenu={this.props.restaurantMenu}
            options={this.props.options}
            values={this.props.values}
            onChange={this.props.onChange}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
